import { z } from 'zod';

/** Persönliche Sichtbarkeit zusätzlicher Bereiche, unabhängig von Rechten und Daten. */
export interface NavigationPrefs {
  showOverview: boolean;
  showPlanning: boolean;
}

export function navigationPrefsOf(value?: Partial<NavigationPrefs> | null): NavigationPrefs {
  return { showOverview: value?.showOverview !== false, showPlanning: value?.showPlanning !== false };
}

/** Nur übergebene Schalter ändern, damit parallele Geräte andere Schalter erhalten. */
export const navigationPrefsPatchSchema = z.object({
  showOverview: z.boolean().optional(),
  showPlanning: z.boolean().optional(),
}).strict().refine((v) => Object.keys(v).length > 0, 'Mindestens eine Einstellung angeben.');
